import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { SiteContentProvider, useSiteContent } from "./context/SiteContentContext";

// Refresca el contenido del sitio cada vez que se navega entre páginas,
// para que los cambios guardados en el panel de administración se vean al momento.
function ContentRefresher() {
  const location = useLocation();
  const { refresh } = useSiteContent();

  useEffect(() => {
    refresh();
  }, [location.pathname, refresh]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <SiteContentProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ContentRefresher />
          <AppRoutes />
        </BrowserRouter>
      </SiteContentProvider>
    </I18nextProvider>
  );
}

export default App;